import { Box, IconButton, Tooltip } from "@mui/material";
import { Typography, useMediaQuery } from "@mui/material";
import { ContainerForGrid, exploreTracksStyles } from "./styles";
import { ExploreArtistsCardProps } from "./types";
import { useContext } from "react";
import { TalkJsContext, TalkJsContextInterface } from "../../contexts";
import { Collaborator } from "../../proto/api_pb";
import { useNavigate } from "react-router-dom";
import { THEME } from "../../theme";
import { handleCreateGroupChat } from "../TrackComponents/TrackHandler/trackHandlers";
import { useAuth0 } from "@auth0/auth0-react";

export const ExploreArtistsCard: React.FC<ExploreArtistsCardProps> = ({
  artists,
  title,
  session,
  setInbox,
}) => {
  const talkJsContext = useContext<TalkJsContextInterface>(TalkJsContext);
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const { isAuthenticated } = useAuth0();

  const createGroupChat = (
    id: string | undefined,
    title: string | undefined,
    contributors: Collaborator[] | undefined
  ) => {
    handleCreateGroupChat(
      talkJsContext,
      contributors,
      navigate,
      undefined,
      id,
      title
    );
  };
  return (
    <>
      <Box>
        <Typography sx={exploreTracksStyles.titleContainer} variant="h5">
          {title}
        </Typography>
        <ContainerForGrid>
          {artists && artists.length > 0
            ? artists.map((artist, i) => (
                <Box
                  onClick={() => {
                    navigate("/user-profile/" + artist.getUsername(), {
                      state: "back",
                    });
                  }}
                  key={i}
                  sx={{
                    ...exploreTracksStyles.cardContainer,
                    ...{
                      "&:hover": {
                        cursor: "pointer",
                      },
                    },
                  }}
                >
                  <Box sx={{ height: "80%" }}>
                    <img
                      style={exploreTracksStyles.img}
                      src={
                        artist.getProfilePicture().includes("http")
                          ? artist.getProfilePicture()
                          : "/assets/images/logo512.png"
                      }
                      alt={`${i}`}
                    />
                  </Box>
                  <Box sx={exploreTracksStyles.bottomContainer}>
                    <Box sx={exploreTracksStyles.artistUserNameContainer}>
                      <Typography>{artist.getUsername()}</Typography>
                    </Box>
                    {isAuthenticated && (
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          if (session) {
                            const talkInbox = session.createInbox();
                            setInbox(talkInbox);
                            talkJsContext.setIsChatOpen(true);
                            const c = new Collaborator();
                            c.setUserId(artist.getUserId());
                            c.setUsername(artist.getUsername());
                            createGroupChat(
                              artist.getUserId(),
                              artist.getUsername(),
                              [c]
                            );
                          }
                          if (isSmallScreen) navigate("/messages");
                        }}
                      >
                        <Tooltip placement="top" title="Chat with the artists">
                          <img
                            style={{
                              filter:
                                THEME === "light"
                                  ? "invert(100%)"
                                  : "invert(0%)",
                            }}
                            src="/assets/icons/TracksPageIcons/message-chat-circle.svg"
                            alt="icon"
                          />
                        </Tooltip>
                      </IconButton>
                    )}
                  </Box>
                </Box>
              ))
            : null}
        </ContainerForGrid>
      </Box>
    </>
  );
};
